/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_3_PInputs */

const en_privacy_3_p = /** @type {(inputs: Privacy_3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your ideas, answers, documents, chat messages and codebase summaries are sent to third-party large-language-model providers to generate results. They are transmitted over encrypted connections and processed under the providers' API terms, which exclude training on API inputs.`)
};

const id_privacy_3_p = /** @type {(inputs: Privacy_3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ide, jawaban, dokumen, pesan chat, dan ringkasan codebase dikirim ke penyedia model bahasa pihak ketiga untuk menghasilkan keluaran. Data dikirim lewat koneksi terenkripsi dan diproses sesuai ketentuan API penyedia, yang tidak memakai input API untuk pelatihan.`)
};

/**
* | output |
* | --- |
* | "Your ideas, answers, documents, chat messages and codebase summaries are sent to third-party large-language-model providers to generate results. They are tra..." |
*
* @param {Privacy_3_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_3_p = /** @type {((inputs?: Privacy_3_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_3_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_3_p(inputs)
	return en_privacy_3_p(inputs)
});